
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import Differences from './components/Differences';
import ProgramFlow from './components/ProgramFlow';
import TargetAudience from './components/TargetAudience';
import CTA from './components/CTA';
import Closing from './components/Closing';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  const [isNavbarFixed, setIsNavbarFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsNavbarFixed(true);
      } else {
        setIsNavbarFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-white">
      <Navbar isFixed={isNavbarFixed} />
      <Hero />
      <Introduction />
      <Differences />
      <ProgramFlow />
      <TargetAudience />
      <CTA />
      <Closing />
      <Footer />
    </div>
  );
}
